import { createAction, props } from '@ngrx/store';
import {
  CourseCategory,
  CourseDTO,
  CourseItem,
  CourseResponseDTO,
} from './models';
import { CourseContent } from './models/course-contents.model';

export const fetchCourseItems = createAction(
  '[Course API] Fetch All Course Items',
  props<{ page: number }>()
);

export const fetchCourseItemsSuccess = createAction(
  '[Course API] Fetch Course Items Success',
  props<{ courseResponse: CourseResponseDTO }>()
);

export const fetchCourseItemsFailed = createAction(
  '[Course API] Fetch Course Items Failed',
  props<{ error: any }>()
);

export const selectCourseItem = createAction(
  '[Course API] Select Course Item',
  props<{ id: string }>()
);

export const selectCourseItemSuccess = createAction(
  '[Course API] Select Course Item Success',
  props<{ item: CourseItem }>()
);

export const initiateCourseCreation = createAction(
  '[Course API] Initiate Course Creation'
);

export const initiateCourseCreationSuccess = createAction(
  '[Course API] Initiate Course Creation Success',
  props<{ categories: CourseCategory[] }>()
);

export const createCourseItem = createAction(
  '[Course API] Create Course Item',
  props<{ courseItemDTO: CourseDTO }>()
);

export const createCourseItemSuccess = createAction(
  '[Course API] Create Course Item Success',
  props<{ courseItem: CourseItem }>()
);

export const updateCourseItem = createAction(
  '[Course API] Update Course Item',
  props<{ courseId: string; courseItemDTO: CourseDTO }>()
);

export const updateCourseItemSuccess = createAction(
  '[Course API] Update Course Item Success',
  props<{ courseItem: CourseItem }>()
);

export const updateCourseItemFailed = createAction(
  '[Course API] Update Course Item Failed',
  props<{ error: any }>()
);

export const restoreCreateCourseItem = createAction(
  '[Course API] Restore Created Course Item',
  props<{ courseId: string }>()
);

export const restoreCreateCourseItemSuccess = createAction(
  '[Course API] Create Course Item Success',
  props<{ courseItem: CourseItem }>()
);

export const createCourseItemFailed = createAction(
  '[Course API] Create Course Item Failed',
  props<{ error: any }>()
);

export const syncCourseContents = createAction(
  '[Course API] Update Course Contents',
  props<{ courseId: string; courseContents: CourseContent[] }>()
);

export const syncCourseContentsSuccess = createAction(
  '[Course API] Update Create Course Contents Success',
  props<{ courseItem: CourseItem }>()
);

export const fetchEnrollments = createAction('[Course API] Fetch Enrollment');

export const fetchEnrollmentsSuccess = createAction(
  '[Course API] Fetch Enrollment Success',
  props<{ enrolledCourses: CourseItem[] }>()
);

export const fetchAllForInstructor = createAction(
  '[Course API] Fetch All Courses for Instructor'
);

export const resetCourseState = createAction('[Course] Reset Course State');

export const clearCreatedCourseItem = createAction(
  '[Course API] Clear Created Course Item'
);

export const requestForReview = createAction(
  '[Course API] Send review request',
  props<{ courseId: string }>()
);

export const requestForReviewSuccess = createAction(
  '[Course API] Request For review success',
  props<{ courseItem: CourseItem }>()
);

export const publishCourse = createAction(
  '[Course API] Publish Course',
  props<{ courseId: string }>()
);

export const publishCourseSuccess = createAction(
  '[Course API] Publish Course Success',
  props<{ courseItem: CourseItem }>()
);

export const publishCourseFailed = createAction(
  '[Course API] Publish Course Failed',
  props<{ error: any }>()
);

// export const fetchAllForInstructorSuccess = createAction(
//   '[Course API] Fetch All Courses for Instructor Success',
//   props<{ enrolledCourses: CourseItem[] }>()
// );
